// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3iVRP","search":"Settings_search__7uplY","filter":"Settings_filter__2Rm-n"};